<div class="background">
  <div class="welcome-text">
        <span>Welcome to the APD/CI Regulatory Competitive Intelligence Database - Crystal</span>
  </div>
</div>

